import React from 'react'

export default function PrivacySettingsIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 3C9.11625 3 6.75 5.36625 6.75 8.25V9H6C5.175 9 4.5 9.675 4.5 10.5V19.5C4.5 20.325 5.175 21 6 21H18C18.825 21 19.5 20.325 19.5 19.5V10.5C19.5 9.675 18.825 9 18 9H17.25V8.25C17.25 5.36625 14.8837 3 12 3ZM12 4.5C14.0662 4.5 15.75 6.18375 15.75 8.25V9H8.25V8.25C8.25 6.18375 9.93375 4.5 12 4.5ZM12 11.25C14.1 11.25 15.75 12.9 15.75 15C15.75 17.1 14.1 18.75 12 18.75C9.9 18.75 8.25 17.1 8.25 15C8.25 12.9 9.9 11.25 12 11.25ZM12 12.75C10.725 12.75 9.75 13.725 9.75 15C9.75 16.275 10.725 17.25 12 17.25C13.275 17.25 14.25 16.275 14.25 15C14.25 14.775 14.1795 14.5455 14.1795 14.3205C13.9545 14.6955 13.575 15 13.125 15C12.525 15 12 14.475 12 13.875C12 13.425 12.3045 13.0455 12.6795 12.8205C12.4545 12.8205 12.225 12.75 12 12.75Z"
                fill="currentColor"
            />
        </svg>
    )
}
